export default {
    state: {
        rechargeValues: [],
        totalRechargeValue: 0,
        storedSons: [],
        rechargeMode: '',
        invoiceTotalValue: 0,
        isInvoiceMode: false,
        idBoletos: []
    },
    mutations: {
        setRechargeValues (state, values) {
            state.totalRechargeValue = values.totalValue
            state.rechargeValues = values.sonsValues
        },
        storeSons (state, sons) {
            state.storedSons = sons
        },
        setRechargeMode (state, mode) {
            state.rechargeMode = mode
        },
        setIsInvoiceMode (state, data) {
            state.isInvoiceMode = data
        },
        setInvoiceTotalValue (state, data) {
            state.invoiceTotalValue = data
        },
        setIdBoletos (state, data) {
            state.idBoletos = data
        }
    },
    actions: {
        setRechargeValues ({ commit }, values) {
            commit('setRechargeValues', values)
        },
        storeSons ({ commit }, sons) {
            commit('storeSons', sons)
        },
        setRechargeMode ({ commit }, mode) {
            commit('setRechargeMode', mode)
        },
        setIsInvoiceMode ({ commit }, data) {
            commit('setIsInvoiceMode', data)
        },
        setInvoiceTotalValue ({ commit }, data) {
            commit('setInvoiceTotalValue', data)
        },
        setIdBoletos ({ commit }, data) {
            commit('setIdBoletos', data)
        }
    },
    getters: {
        totalRechargeValue: (state) => state.totalRechargeValue,
        rechargeMethod: (state) => state.payMethodModal.selectedMethod,
        storedSons: (state) => state.storedSons,
        rechargeValues: (state) => state.rechargeValues,
        rechargeMode: (state) => state.rechargeMode,
        isInvoiceMode: (state) => state.isInvoiceMode,
        invoiceTotalValue: (state) => state.invoiceTotalValue,
        idBoletos: (state) => state.idBoletos
    }
}
